import { render } from "./CitasPorEspecialidad.vue?vue&type=template&id=c456426e&scoped=true"
import script from "./CitasPorEspecialidad.vue?vue&type=script&lang=js"
export * from "./CitasPorEspecialidad.vue?vue&type=script&lang=js"

import "./CitasPorEspecialidad.vue?vue&type=style&index=0&id=c456426e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c456426e"]])

export default __exports__